import PropTypes from 'prop-types';
import { appVersionLabel, productBrandFooterLabel, productBrandFooterProduct } from '../../config/branding';
import { DashboardLayoutCustomizeTrigger } from './DashboardLayoutToolbar';

const DashboardHomeVersionFooter = ({ onCustomizeHome }) => {
	const version = appVersionLabel();
	const ariaLabel = `${productBrandFooterLabel} ${productBrandFooterProduct} ${version}`;

	return (
		<footer className='dashboard-home-version-footer' aria-label={ariaLabel}>
			{onCustomizeHome ? <DashboardLayoutCustomizeTrigger onClick={onCustomizeHome} /> : null}
			<div className='dashboard-home-version-footer__rule' aria-hidden='true' />
			<p className='dashboard-home-version-footer__meta'>
				<span className='dashboard-home-version-footer__company' title={productBrandFooterLabel}>
					{productBrandFooterLabel}
				</span>
				<span className='dashboard-home-version-footer__dot' aria-hidden='true'>
					·
				</span>
				<span className='dashboard-home-version-footer__product' title={productBrandFooterProduct}>
					{productBrandFooterProduct}
				</span>
				<span className='dashboard-home-version-footer__dot' aria-hidden='true'>
					·
				</span>
				<span className='dashboard-home-version-footer__version user-select-all' title='可选中复制版本号'>
					{version}
				</span>
			</p>
		</footer>
	);
};

DashboardHomeVersionFooter.propTypes = {
	onCustomizeHome: PropTypes.func,
};

export default DashboardHomeVersionFooter;
